export default "__VITE_ASSET__D7_nSH98__"